import { render } from "./TicketPrice.vue?vue&type=template&id=cdf9a59c"
import script from "./TicketPrice.vue?vue&type=script&lang=js"
export * from "./TicketPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__